import { graphql } from 'src/gql';

export const CLIENT_PORTAL_CREATE_ACCOUNT = graphql(/* GraphQL */ `
  mutation ClientPortalCreateAccount($input: CreateAccountInput!) {
    createAccount(input: $input) {
      account {
        id
      }
    }
  }
`);

export const CLIENT_PORTAL_CREATE_ASSET = graphql(/* GraphQL */ `
  mutation ClientPortalCreateAsset($input: CreateAssetInput!) {
    createAsset(input: $input) {
      asset {
        id
      }
    }
  }
`);

export const CLIENT_PORTAL_CREATE_LIABILITY = graphql(/* GraphQL */ `
  mutation ClientPortalCreateLiability($input: CreateLiabilityInput!) {
    createLiability(input: $input) {
      liability {
        id
      }
    }
  }
`);
